import { BCMSRecord, BCMSRecordProperty } from "@bcm-dev/bcms-vite";

/**
 * @class ParticipantImportTemplate
 * @classdesc Class definition for record type from model
 * @param {OBJECT} record - record from the model to init class
 * @extends BCMSRecord
 * @example const notification = new ParticipantImportTemplate(model.participantImportTemplate[0]);
 *
 * @property {NUMBER} _id - The id of the participant import template
 * @property {STRING} _participantName - The name field of the participant import template
 * @property {STRING} _nickname - The nickname field of the participant import template
 * @property {STRING} _institutionName - The institutionName field of the participant import template
 * @property {NUMBER} _uniqueID - The uniqueID field of the participant import template
 * @property {bcmsDate} _updatedDate - The update date field of the participant import template
 * @property {STRING} _group - The group field of the participant import template
 * @property {STRING} _number - The number field of the participant import template
 * @property {STRING} _routing - The routing field of the participant import template
 * @property {STRING} _status - The status field of the participant import template
 * @property {STRING} _discretionaryData - The discretionaryData field of the participant import template
 */
export default class ParticipantImportTemplate extends BCMSRecord {
  _id;
  _templateName;
  _participantName;
  _nickname;
  _institutionName;
  _routing;
  _number;
  _uniqueID;
  _status;
  _group;
  _discretionaryData;
  _updatedDate;

  constructor(record) {
    super(record);
  }
}

ParticipantImportTemplate.define({
  recordType: "participantImportTemplate",
  recordIDProp: "id",
  className: "ParticipantImportTemplate",
  recordProperties: [
    /**
     * @id
     * @instance
     * @property get {NUMBER} - gets the id field of the participant import template
     * @property set {NUMBER} - sets the id field of the participant import template
     * @memberof ParticipantImportTemplate
     */
    BCMSRecordProperty.mapToNumber("id", "_id"),

    /**
     * @templateName
     * @instance
     * @property get {STRING} - gets the templateName field of the participant import template
     * @property set {STRING} - sets the templateName field of the participant import template
     * @memberof ParticipantImportTemplate
     */
    BCMSRecordProperty.mapToString("templateName", "_templateName"),

    /**
     * @updatedDate
     * @instance
     * @property get {STRING} - gets the updatedDate property of a participant import template in a component row
     * @property set {STRING} - sets the updatedDate property of a participant import template  in a component row
     * @memberof ParticipantImportTemplate
     */
    BCMSRecordProperty.mapToDate("updatedDate", "_updatedDate"),

    /**
     * @participantName
     * @instance
     * @property get {STRING} - gets the name field of the participant import template
     * @property set {STRING} - sets the name field of the participant import template
     * @memberof ParticipantImportTemplate
     */
    BCMSRecordProperty.mapToString("participantName", "_participantName"),

    /**
     * @nickname
     * @instance
     * @property get {STRING} - gets the nickname field of the participant import template
     * @property set {STRING} - sets the nickname field of the participant import template
     * @memberof ParticipantImportTemplate
     */
    BCMSRecordProperty.mapToString("nickname", "_nickname"),

    /**
     * @institutionName
     * @instance
     * @property get {STRING} - gets the institutionName field of the participant import template
     * @property set {STRING} - sets the institutionName field of the participant import template
     * @memberof ParticipantImportTemplate
     */
    BCMSRecordProperty.mapToString("institutionName", "_institutionName"),

    /**
     * @routing
     * @instance
     * @property get {STRING} - gets the routing field of the participant import template
     * @property set {STRING} - sets the routing field of the participant import template
     * @memberof ParticipantImportTemplate
     */
    BCMSRecordProperty.mapToString("routing", "_routing"),

    /**
     * @number
     * @instance
     * @property get {STRING} - gets the number field of the participant import template
     * @property set {STRING} - sets the number field of the participant import template
     * @memberof ParticipantImportTemplate
     */
    BCMSRecordProperty.mapToString("number", "_number"),

    /**
     * @accountType
     * @instance
     * @property get {STRING} - gets the accountType field of the participant import template
     * @property set {STRING} - sets the accountType field of the participant import template
     * @memberof ParticipantImportTemplate
     */
    BCMSRecordProperty.mapToString("accountType", "_accountType"),

    /**
     * @uniqueID
     * @instance
     * @property get {STRING} - gets the uniqueID field of the participant import template
     * @property set {STRING} - sets the uniqueID field of the participant import template
     * @memberof ParticipantImportTemplate
     */
    BCMSRecordProperty.mapToString("uniqueID", "_uniqueID"),

    /**
     * @status
     * @instance
     * @property get {STRING} - gets the status field of the participant import template
     * @property set {STRING} - sets the status field of the participant import template
     * @memberof ParticipantImportTemplate
     */
    BCMSRecordProperty.mapToString("status", "_status"),

    /**
     * @group
     * @instance
     * @property get {STRING} - gets the group field of the participant import template
     * @property set {STRING} - sets the group field of the participant import template
     * @memberof ParticipantImportTemplate
     */
    BCMSRecordProperty.mapToString("group", "_group"),

    /**
     * @discretionaryData
     * @instance
     * @property get {STRING} - gets the discretionaryData field of the participant import template
     * @property set {STRING} - sets the discretionaryData field of the participant import template
     * @memberof ParticipantImportTemplate
     */
    BCMSRecordProperty.mapToString("discretionaryData", "_discretionaryData"),
  ],
});
